/*
This action file conatin the action related to system, like logs etc
*/
import * as api from '../api';

export const getSystemLogs = (args) => {

  return (dispatch, getState) => {

    dispatch({
      type: 'SYSTEM_LOG_REQUEST'
    });

    return api.getSystemLogs(args).then(
      (response) => {
        dispatch({
          type: 'SYSTEM_LOG_SUCCESS',
          paylod: response.logs
        });
      },
      (error) => {
        dispatch({
          type: 'SYSTEM_LOG_ERROR',
          error: error
        });
      }
    );
  };
};




// WEBPACK FOOTER //
// ./src/Actions/system.js